import Vue from 'vue'

export async function handleMfaRequestOtpError(
  error: any,
  refreshProfile?: () => Promise<void>
): Promise<void> {
  const data = error?.data || error

  const status = data?.error_id
  const message = data?.message?.id || 'Terjadi kesalahan'

  switch (status) {
    case 409:
      if (refreshProfile) {
        await refreshProfile()
      }

      Vue.notify({
        type: 'info',
        text: 'Verifikasi OTP sudah aktif',
        duration: 3000,
      })
      break

    case 403:
    case 423:
    case 422:
    case 400:
    case 440:
      Vue.notify({
        type: 'error',
        text: message,
        duration: 3000,
      })
      break

    default:
      Vue.notify({
        type: 'error',
        text: 'Gagal mengirim OTP',
      })
  }
}